import { deepClone } from './deepClone';

/**
 * Calculates which categories to display based on active item and allowed items count
 * Ensures center alignment with the active item in the middle
 *
 * @param {Array} categories - List of category objects with id, active, and category_title
 * @param {number} activeIndex - Index of the currently active category
 * @param {number} allowedItems - Maximum number of items that can be displayed
 * @returns {Array} Array of displayed categories with correct active states
 *
 * @example
 * const displayed = calculateDisplayedCategories(categories, 2, 5);
 * // Returns 5 items centered around activeIndex 2
 */
export const calculateDisplayedCategories = (categories, activeIndex, allowedItems) => {
  if (!categories || categories.length === 0) {
    return [];
  }

  const totalItems = categories.length;
  const displayedItems = [];

  // Ensure we always display an odd number of items for center alignment
  const maxIterations = Math.min(allowedItems, totalItems % 2 !== 0 ? totalItems : totalItems - 1);

  // Calculate items with active item centered
  for (let i = 0; i < maxIterations; i++) {
    const index = (activeIndex - Math.floor(maxIterations / 2) + i + totalItems) % totalItems;
    const item = deepClone(categories[index]);
    item.active = index === activeIndex;
    displayedItems.push(item);
  }

  return displayedItems;
};
